/* eslint-disable import/prefer-default-export */

// Profile 
export const PROFILE_SIGNATURE = '/api/v1/user/signature';
export const PROFILE_SIGNATURE_UPLOAD = `${PROFILE_SIGNATURE}/upload`;